import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    isLoading: false,
    error: null,
    allblog: [],
    oneblog: {},
};

const accessToken = typeof window !== "undefined" ? localStorage.getItem("accessToken") : "";

const headers = {
    'Authorization': `Bearer ${accessToken}`,
    'Content-Type': 'application/json'
};

// Create the slice
const blogSlice = createSlice({
    name: "blog",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
            state.error = null;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getAllblogSuccess(state, action) {
            state.isLoading = false;
            state.allblog = action.payload;
        },
        getOneblogSuccess(state, action) {
            state.isLoading = false;
            state.oneblog = action.payload;
        },
    },
});

export const {
    startLoading,
    hasError,
    getAllblogSuccess,
    getOneblogSuccess
} = blogSlice.actions;

export default blogSlice.reducer;

export const getBlog = () => async (dispatch) => {
    try {
        dispatch(startLoading());
        const response = await axios.get(`/blogs`, { headers });
        dispatch(getAllblogSuccess(response?.data?.blogs));
    } catch (error) {
        console.error("Unable to retrieve blogs. Please try again later.", error);
        dispatch(hasError(error.message || "Error retrieving blogs"));
    }
};

// ✅ API: Get one blog by ID
export const getOnebLog = (id) => async (dispatch) => {
    try {
        dispatch(startLoading());
        const response = await axios.get(`/blogs/${id}`, { headers });
        dispatch(getOneblogSuccess(response?.data?.blog));
    } catch (error) {
        console.error("Failed to load blog details. Please try again later.", error);
        dispatch(hasError(error.message || "Error loading blog details"));
    }
};
